"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query roles($query: QueryInput, $pagination: PaginationInput) {
    roles(query: $query, pagination: $pagination) {
      _id
      userId
      userEmail
      user {
        _id
        firstName
        lastName
        email
        userProfile {
          imageUrl
          authyId
        }
      }
      orgId
      role
      createdAt
      createdBy
      acceptedAt
    }
  }
`;
exports.default = query;
//# sourceMappingURL=roles.query.js.map